<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addController" v-if="permissionCodes.indexOf('007002001') !== -1"/>
      </div>
      <input-search placeholder="访客机名称/序列号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="goToModifyPage" @deleteLine="deleteLine" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Visitor";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "visitor-device-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧访客",
          name: "visitor-device-manage"
        },
        {
          value: "访客机管理"
        }
      ],
      addController: "visitor-device-add",
      exportUrl: "",
      tableHead: [
        {
          prop: "deviceName",
          label: "访客机名称"
        },
        {
          prop: "deviceSn",
          label: "访客机序列号"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: ""
      },
      operationArr: ["modify", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    // 获取控制器
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getDevicePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取访客机列表失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    goToModifyPage(code) {
      let data = {};
      this.tableData.map(v => {
        if (v.code === code) {
          data = v;
        }
      });
      this.$router.push({
        name: "visitor-device-modify",
        params: data
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteDevice, { codes: code.join(",") })
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/VisitorDevice/VisitorDeviceManage.vue